import { IFilterQueryParams } from '@clientShared/filter.types';
import easyfyAxios from '@shared/easyfy.axios';

namespace Services.Filter {
  export const GetProducts = async (
    pageId: string,
    data: IFilterQueryParams,
    filterFor: string,
    productListName: string,
    productListId: string,
    pathName: string
  ): Promise<any> => {
    productListName = encodeURIComponent(productListName);
    return await easyfyAxios.post(
      `/category?handler=ProductList&pageId=${pageId}&filterFor=${filterFor}&productListName=${productListName}&productListId=${productListId}&pathName=${pathName}`,
      data
    );
  };

  export const GetSubscriptionProducts = async (pageId: string, data: IFilterQueryParams, productListName: string, productListId: string): Promise<any> => {
    productListName = encodeURIComponent(productListName);
    return await easyfyAxios.post(`/subscription?handler=ProductList&pageId=${pageId}&productListName=${productListName}&productListId=${productListId}`, data);
  };

  export const GetArticles = async (pageId: string, data: IFilterQueryParams): Promise<any> => {
    return await easyfyAxios.post(`/articlelist?handler=ArticleList&pageId=${pageId}`, data);
  };

  export const GetMoreOrders = async (page: number): Promise<any> => {
    return await easyfyAxios.get(`/mypages/orderlist?handler=MoreOrders&page=${page}`);
  };
}

export default Services.Filter;
